/**
 * CatchBoundary error UI for `/area/$areaId` (plan §1.4 · error §6 · AD-9).
 *
 * Discriminates InvalidAreaParamError from render-time crashes so a members
 * table exception is never reported as "unknown industry".
 */
import { EmptyState } from '@/components/primitives/empty-state';

import { isInvalidAreaParamError } from './invalid-area-param-error';

import type { JSX } from 'react';

export function AreaRouteError({ error }: { readonly error: unknown }): JSX.Element {
  if (isInvalidAreaParamError(error)) {
    return (
      <EmptyState title="Area not found" description="Invalid or unknown industry in the URL." />
    );
  }
  return (
    <EmptyState
      title="Something went wrong"
      description="This screen could not be displayed. Reload the page to try again."
    />
  );
}
